let RE_NOT_LETTER: RegExp;

try {
  // Digits are part of a word: usernames here are often employee codes like `8030`. Without `\p{N}` a
  // digit-only query split into nothing but empty words, which every chat matched, so the list filled
  // with unrelated chats and pushed the real result behind "Show More".
  RE_NOT_LETTER = /[^\p{L}\p{M}\p{N}]+/ui;
} catch (e) {
  // Support for older versions of firefox
  RE_NOT_LETTER = /[^\wа-яёґєії]+/i;
}

export default function searchWords(haystack: string, needle: string | string[]) {
  if (!haystack || !needle) {
    return false;
  }

  const needleWords = typeof needle === 'string' ? splitNeedle(needle) : needle;
  if (!needleWords.length) {
    return false;
  }

  const haystackLower = haystack.toLowerCase();

  // @optimization
  if (needleWords.length === 1 && !haystackLower.includes(needleWords[0])) {
    return false;
  }

  let haystackWords: string[];

  return needleWords.every((needleWord) => {
    if (!haystackLower.includes(needleWord)) {
      return false;
    }

    if (!haystackWords) {
      haystackWords = haystackLower.split(RE_NOT_LETTER);
    }

    return haystackWords.some((haystackWord) => haystackWord.startsWith(needleWord));
  });
}

export function prepareSearchWordsForNeedle(needle: string) {
  const needleWords = splitNeedle(needle);

  return (haystack: string) => searchWords(haystack, needleWords);
}

// Punctuation at either end (`@8030`, `"anh"`) splits off an empty word that every haystack contains.
function splitNeedle(needle: string) {
  return needle.toLowerCase().split(RE_NOT_LETTER).filter(Boolean);
}
